export default {
  BASE_URL: 'content/cmsNotice',
  api: [
    {
      name: 'categories',
      method: 'GET',
      desc: '获取帮助分类',
      path: 'catalogList'
    },
    {
      name: 'updateCategorySortNum',
      method: 'POST',
      desc: '更新分类排序顺序',
      path: 'upCataSort',
      params: {
        ids: ''
      }
    },
    {
      name: 'list',
      method: 'GET',
      desc: '获取帮助信息列表',
      path: 'noticeList',
      params: {
        noticeTitle: '', // 标题或发布人姓名
        noticeCataId: '', // 分类id
        order: '', // 排序规则
        prop: '', // 排序字段
        pageNum: 1,
        pageSize: 25
      }
    },
    {
      name: 'addCategory',
      method: 'POST',
      desc: '新增帮助信息分类',
      path: 'addCatalog',
      params: {
        cataName: '', // 类型名称
        cataStatus: 0 // 类型状态 0 未启用 1 启用 2 停用
      }
    },
    {
      name: 'updateCategory',
      method: 'POST',
      desc: '编辑帮助信息分类',
      path: 'editCatalog',
      params: {
        cataName: '',
        cataStatus: '',
        id: '' // 分类id
      }
    },
    {
      name: 'updateCategoryStatus',
      method: 'POST',
      desc: '启用/停用帮助信息分类',
      path: 'upCataStatus',
      params: {
        id: '',
        cataStatus: ''
      }
    },
    {
      name: 'deleteCategory',
      method: 'GET',
      desc: '删除帮助分类',
      path: 'delCatalog',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'add',
      method: 'POST',
      desc: '新增帮助信息',
      path: 'addInfo',
      params: {
        noticeTitle: '',
        seoKeyword: '',
        noticeCataId: '',
        isRelease: '',
        noticeSummary: '',
        sortNum: '',
        noticeContent: ''
      }
    },
    {
      name: 'edit',
      method: 'POST',
      desc: '编辑帮助信息',
      path: 'editInfo',
      params: {
        id: '',
        noticeTitle: '',
        seoKeyword: '',
        noticeCataId: '',
        isRelease: '',
        noticeSummary: '',
        sortNum: '',
        noticeContent: ''
      }
    },
    {
      name: 'info',
      method: 'GET',
      desc: '帮助详情',
      path: 'noticeInfo',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'getSortNum',
      method: 'GET',
      desc: '获取排序号',
      path: 'getSortNum',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '删除帮助信息',
      path: 'delDetail',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'updateStatus',
      method: 'POST',
      desc: '更新是否发布状态',
      path: 'upRelease',
      params: {
        id: '',
        isRelease: ''
      }
    },
    {
      name: 'checkCategoryName',
      method: 'POST',
      desc: '检查分类名称是否重复',
      path: 'checkCataName',
      params: {
        id: '',
        cataName: ''
      }
    },
    {
      name: 'getCategoryById',
      method: 'POST',
      desc: '根据分类id获取分类信息',
      path: 'cataInfo',
      params: {
        id: ''
      }
    },
    {
      name: 'checknoticeName',
      method: 'POST',
      desc: '检查帮助名称',
      path: 'checkNoticeName',
      params: {
        id: '',
        noticeTitle: ''
      }
    },
    {
      name: 'updateRecommend',
      method: 'POST',
      desc: '更新是否推荐',
      path: '/upRecommend'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/notice.js